import { Injectable } from '@angular/core';

import { Geolocation, Geoposition } from '@ionic-native/geolocation';
import { Api } from '../api/api';

@Injectable()
export class GeoProvider {

  constructor(public api: Api, public geo: Geolocation) { }

  updateLocation(): void {
    console.log("***** update location");
    this.geo.getCurrentPosition().then((resp: Geoposition) => {
      console.log("***** get location success");
      console.log(resp);
      this.api.patch('me/location', {
        user_location: {
          latitude: resp.coords.latitude,
          longitude: resp.coords.longitude
        }
      }).subscribe((data) => {
        console.log("***** api success");
        console.log(data);
        // nothing to do
      }, error => {
        console.log("***** api error");
        console.log(error);
        // nothing to do
      });
    }, error => {
      console.log("***** get location error");
      console.log(error);
      // nothing to do
    });
  }

}



// WEBPACK FOOTER //
// ./src/providers/geo/geo.ts